$(function () {
    $('.voice-group').slick({
        infinite: true,
        slidesToShow: 1,
        variableWidth: true,
        centerMode: true,
        swipeToSlide: true,
    });

    $('.courses-group').slick({
        infinite: true,
        slidesToShow: 1,
        variableWidth: true,
        centerMode: true,
        swipeToSlide: true,
    });

    $('.plans-group').slick({
        infinite: false,
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
        slidesToScroll: 1,
        initialSlide: 1,
        responsive: [
            {
                breakpoint: 344 * 3,
                settings: {
                    slidesToShow: 2,
                    initialSlide: 0,
                    centerMode: false,
                }
            },
            {
                breakpoint: 344 * 2,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 0,
                    centerMode: true,
                }
            },

        ]
    });
});
